import React, { useEffect, useState } from 'react';
import { Menu, XSquare } from 'react-feather';
import { Link } from 'react-router-dom';
import { handCursor } from '../../Constant/constant';
import { FlexCol, FlexContainer, FlexRowHeader } from '../../Styles';
import Logo from './../../assets/Logo/steven_logo.webp'
import './style.css'

const Header = (props) => {

    const [screenSize, setscreenSize] = useState(window.innerWidth);
    const [showMenu, setMenu] = useState("none");

    const resizeWindow = () => {
        if (window.innerWidth !== screenSize) {
            setscreenSize(window.innerWidth);
        }
    }
    useEffect(() => {
        window.addEventListener("resize", resizeWindow);
    }, [])

    return (
        <FlexContainer className="px-5">
            <FlexRowHeader>
                <FlexCol size="6" className="LogoName" basis="60%" grow="1">
                    <img src={Logo} style={{ filter: 'hue-rotate(180deg)' }} id="icon" x="0" y="0" width="120" height="120" transform="translate(0 233.37873026) " alt="Logo" />
                </FlexCol>
                <FlexCol size="1" className="headerLink" basis="auto" grow="1">
                    <Link to="/" className={props.selected === "HOME" ? "selected-page color-grey" : "color-grey"} style={{ cursor: handCursor }}>HOME</Link>
                </FlexCol>
                <FlexCol size="1" className="headerLink" basis="auto" grow="1">
                    <Link to="/projects" className={props.selected === "PROJECT" ? "selected-page color-grey" : "color-grey"} style={{ cursor: handCursor }}>PROJECTS</Link>
                </FlexCol>
                <FlexCol size="1" className="headerLink" basis="auto" grow="1">
                    <Link to="/contact" className={props.selected === "CONTACT" ? "selected-page color-grey" : "color-grey"} style={{ cursor: handCursor }}>CONTACT</Link>
                </FlexCol>
                {screenSize < 800 ?
                    <FlexCol size="1" basis="auto" grow="1">
                        <Menu size={40} onClick={() => setMenu("flex")} />
                        <div className="headerLinkMobile" style={{ display: showMenu }} onClickCapture={() => setMenu("none")}>
                            <div className="close" onClick={() => setMenu("none")}>
                                <XSquare size={40} />
                            </div>
                            <Link to="/" style={{ cursor: handCursor }} onCl>HOME</Link>
                            <Link to="/projects" style={{ cursor: handCursor }}>PROJECTS</Link>
                            <Link to="/contact" style={{ cursor: handCursor }}>CONTACT</Link>
                        </div>
                    </FlexCol>
                    : null
                }
            </FlexRowHeader>
        </FlexContainer >
    );
}

export default Header;